/**
 * Hand off to the OS in-app review flow (specs/review-prompt).
 * The OS sheet is quota-limited and can silently not appear even when available —
 * callers must keep post-call copy neutral (never "thanks for rating").
 * Unavailable / failed → fall back to opening the store page.
 */

import { Platform } from 'react-native';
import * as StoreReview from 'expo-store-review';
import { openAppStore } from './openAppStore.helper';
import { logger } from '../../helpers/logger.helper';

export async function requestStoreReview(): Promise<void> {
  if (Platform.OS === 'web') return;
  const platform = Platform.OS === 'ios' ? 'ios' : 'android';
  try {
    if (await StoreReview.isAvailableAsync()) {
      await StoreReview.requestReview();
      return;
    }
  } catch (error) {
    logger.warn('[requestStoreReview] in-app review failed, falling back to store page', {
      message: error instanceof Error ? error.message : String(error),
    });
  }
  await openAppStore(platform);
}
